import { useDispatch } from "react-redux";
import "./App.css";
import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  useLocation,
  Navigate,
} from "react-router-dom";
import { AgentHeader } from "./components/Header";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Banner from "./pages/Banner";
import AgentLogin from "./pages/AgentLogin";
import AgentPage from "./pages/Home";
import AddImages from "./pages/AddImages";
import { SingleSchema } from "./components/Schema";
import EditProperty from "./pages/EditProperty";
import AgencyRecommendations from "./pages/AgencyRecommendations";
import AgentsProtectedRoute from "./components/Routing/AgentProtectedRoute";
import { ProtectedPage, ManagerPage } from "./components/Routing/ProtectedPage";
import { userProfile } from "./state/actions/accountActions";
import {
  getFilters,
  getTranslations,
  getCities,
} from "./state/actions/staticActions";
import { fetchAgencies } from "./state/actions/agencyActions";

const AgentPortal = () => (
  <>
    <AgentHeader />
    <Outlet />
  </>
);

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return children;
};

function AppContent() {
  const dispatch = useDispatch();

  const [isLoaded, setLoaded] = useState(false);
  const [isLoadedProfile, setLoadedProfile] = useState(false);

  useEffect(() => {
    Promise.all([
      dispatch(getFilters()),
      dispatch(getTranslations()),
      dispatch(getCities()),
    ]).then(() => setLoaded(true));

    dispatch(userProfile())
      .then(() => setLoadedProfile(true))
      .catch(() => setLoadedProfile(true));
    dispatch(fetchAgencies());
  }, [dispatch]);

  if (!isLoaded || !isLoadedProfile) {
    return null;
  }
  return (
    <>
      <ScrollToTop>
        <HelmetProvider>
          <Helmet>
            {import.meta.env.VITE_APP_ENV !== "production" && (
              <>
                <meta name="googlebot" content="noindex" />
                <meta name="googlebot-news" content="nosnippet" />
                <meta name="googlebot-news" content="noindex" />
                <meta name="robots" content="noindex" />
              </>
            )}
          </Helmet>
          <Routes>
            <Route exact path="/banner" element={<Banner />} />
            <Route path="/" element={<AgentPortal />}>
              <Route index element={<Navigate to="/home" />} />
              <Route path="login" element={<AgentLogin />} />
              <Route
                path="home"
                element={
                  <ProtectedPage title="AgentPortal - Home">
                    <AgentPage />
                  </ProtectedPage>
                }
              />
              <Route
                path="home/:id"
                element={
                  <ProtectedPage title="AgentPortal - Home">
                    <AgentPage />
                  </ProtectedPage>
                }
              />
              <Route
                path="property/pictures/:id"
                element={
                  <ProtectedPage title="AgentPortal - Edit Pictures">
                    <AddImages />
                  </ProtectedPage>
                }
              />
              <Route
                path="property/schema/:id"
                element={
                  <ProtectedPage title="AgentPortal - Scheme">
                    <SingleSchema />
                  </ProtectedPage>
                }
              />
              <Route
                path="recommendations/:id"
                element={
                  <ManagerPage title="AgentPortal - Recommendations">
                    <AgencyRecommendations />
                  </ManagerPage>
                }
              />
              <Route
                path="properties/edit/:id"
                element={
                  <ProtectedPage title="AgentPortal - Edit Property">
                    <EditProperty />
                  </ProtectedPage>
                }
              />
              <Route
                path="properties/edit/images/:id"
                element={
                  <AgentsProtectedRoute>
                    <AddImages />
                  </AgentsProtectedRoute>
                }
              />
              <Route
                path="properties/add"
                element={
                  <ProtectedPage title="AgentPortal - Add Property">
                    <EditProperty />
                  </ProtectedPage>
                }
              />
              <Route path="*" element={<Navigate to="/home" />} />
            </Route>
          </Routes>
        </HelmetProvider>
      </ScrollToTop>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <ToastContainer />
      <AppContent />
    </Router>
  );
}
